import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = {
    checkUrl: String,
    activeStatuses: { type: Array, default: ["in_progress", "waiting", "waiting_for_answer", "reactivated"] },
    cancelLabel: { type: String, default: "Cancel" },
    confirmLabel: { type: String, default: "Confirm" }
  }

  connect() {
    this.confirmed = false
  }

  enableSave() {
    const btn = document.querySelector("#save-button")
    if (btn) btn.classList.remove("disabled")
  }

  submit(event) {
    if (this.confirmed) {
      this.confirmed = false
      return
    }

    const selectedStatus = this.statusTarget.value
    if (this.activeStatusesValue.includes(selectedStatus)) return

    event.preventDefault()
    this.checkDraft()
  }

  async checkDraft() {
    const response = await fetch(this.checkUrlValue, {
      headers: { "Accept": "application/json" }
    })
    const { warning } = await response.json()

    if (!warning) {
      this.confirmed = true
      this.element.requestSubmit()
      return
    }

    this.showDialog(warning)
  }

  showDialog(message) {
    const dialog = document.createElement("dialog")
    dialog.classList.add(
      "rounded-xl", "p-6", "max-w-md", "shadow-lg",
      "backdrop:bg-black/50"
    )
    dialog.innerHTML = `
      <p class="mb-6 text-gray-800">${message}</p>
      <div class="flex justify-end gap-3">
        <button data-action="cancel" class="px-4 py-2 rounded-full border border-gray text-gray-600 hover:bg-gray-50">
          ${this.cancelLabelValue}
        </button>
        <button data-action="confirm" class="px-4 py-2 rounded-full bg-blue-400 text-white hover:bg-blue-500">
          ${this.confirmLabelValue}
        </button>
      </div>
    `

    dialog.querySelector("[data-action=cancel]").addEventListener("click", () => {
      dialog.close()
      dialog.remove()
    })

    dialog.querySelector("[data-action=confirm]").addEventListener("click", () => {
      dialog.close()
      dialog.remove()
      this.confirmed = true
      this.element.requestSubmit()
    })

    document.body.appendChild(dialog)
    dialog.showModal()
  }
}
